import { MatSnackBarConfig } from '@angular/material/snack-bar';
import { ComponentType } from '@angular/cdk/portal';

/**
 * Every Custom Component needs to implement this type to be registered with the snackbar.
 *
 * @export
 * @interface SnackBarComponentType
 */
export interface SnackBarComponentType {
  type: string;
}

/**
 * Type of Notifications that are preexisitng
 *
 * @export
 * @enum {number}
 */
export enum NotificationType {
  Success,
  Info,
  Warning,
  Error
}

/**
 * Snackbar types
 *
 * @export
 * @enum {number}
 */
export enum SnackbarType {
  DEFAULT,
  CUSTOM
}

/**
 * @example
 *   {
 *     props: {
 *      message:
 *         auth.loggedIn && auth.user
 *          ? `Welcome back, ${auth.user.userName}`
 *           : `You've been logged out`,
 *       button: {
 *         label: 'Dismiss',
 *         action: actionCallback
 *       },
 *       afterOpenCallback: afterOpenCallback,
 *       afterDismissCallback: afterDismissCallback
 *     }
 *   }
 *
 * @export
 * @interface SnackBarComponentData
 */
export interface SnackBarComponentData {
  props: { [name: string]: any };
  type?: SnackbarType;
}

/**
 * @example
 * {
 *   type: NotificationType.Info,
 *   durationMs:2000,
 *   componentClass: XYZClass<SnackBarComponentType>,
 *   inputs: {
 *     props: {
 *      message:
 *         auth.loggedIn && auth.user
 *          ? `Welcome back, ${auth.user.userName}`
 *           : `You've been logged out`,
 *       button: {
 *         label: 'Dismiss',
 *         action: actionCallback
 *       },
 *       afterOpenCallback: afterOpenCallback,
 *       afterDismissCallback: afterDismissCallback
 *     }
 *   }
 * }
 *
 * @export
 * @interface SnackbarData
 */
export interface SnackbarData {
  inputs: SnackBarComponentData;
  componentClass?: ComponentType<SnackBarComponentType>;
  type?: NotificationType;
  durationMs?: number;
  configs?: MatSnackBarConfig;
}
